export default __webpack_public_path__ + "static/blue-shopping-bag-banner-78e8e45fdb704da5d86e3a84a47437fa.jpg";